import { NgModule } from '@angular/core';
import { MaterialModule } from '../material/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SalesChannelComponent } from './sales-channel.component';
import { MatAutocompleteModule, MatExpansionModule } from '@angular/material';
import { PipesModule } from '../../pipes/pipes.module';
import { SharedModule } from '../../shared/shared.module';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { SalesChannelEditionDialogComponent } from './sales-channel-edition-dialog/sales-channel-edition-dialog.component';

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MatAutocompleteModule,
    PipesModule,
    MatExpansionModule,
    MaterialModule,
    RouterModule,
    SharedModule,
    TranslateModule
  ],
  declarations: [SalesChannelComponent, SalesChannelEditionDialogComponent],
  entryComponents: [SalesChannelEditionDialogComponent]
})
export class SalesChannelModule {}



// WEBPACK FOOTER //
// ./src/app/modules/sales-channels/sales-channel.module.ts